var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showChart)?_c('base-pie-chart',{staticStyle:{"max-height":"250px"},attrs:{"chart-data":_vm.dataCollection,"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }